import styled from '@emotion/styled';
import {ActionLink, ChipGroup} from '@travel-frontend/ui-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  max-width: 100%;
  ${({theme}) => theme.elevations.large}

  ${ChipGroup} {
    padding-top: 16px;

    ${ActionLink} {
      margin-left: auto;
    }
  }
`;
